/* eslint-disable react/prop-types */
import React, { useState } from "react";
import Scrollspy from "react-scrollspy";
import { Box, Circle, Tooltip, VStack } from "@chakra-ui/react";

const ScrollCircle = ({ data }) => {
  const [activeSection, setActiveSection] = useState(null);
  const sectionHeaders = Object.keys(data);

  // Function to handle smooth scrolling
  const handleScrollTo = (sectionId) => {
    const sectionElement = document.getElementById(sectionId);
    if (sectionElement) {
      window.scrollTo({
        top: sectionElement.offsetTop - 100,
        behavior: "smooth",
      });
      setActiveSection(sectionId);
    }
  };

  return (
    <Box position="sticky" top="4" zIndex="10">
      <VStack spacing={6} mb={1}>
        <Scrollspy
          items={sectionHeaders}
          currentClassName="is-active"
          offset={-100}
        >
          {sectionHeaders.map((key, index) => {
            console.log("=======key check", data[key]?.MESSAGE);
            const label = data[key]?.MESSAGE;
            return (
              <Tooltip
                label={label}
                key={key}
                placement="right"
                bg="bgColor"
                color="textColor"
                hasArrow
              >
                <Circle
                  size="25px"
                  bg={
                    activeSection === data[key].MESSAGE ? "bgColor" : "gray.300"
                  }
                  color="white"
                  cursor="pointer"
                  onClick={() => handleScrollTo(data[key].MESSAGE)}
                  boxShadow={activeSection === data[key].MESSAGE ? "lg" : "md"}
                  transition="all 0.3s ease"
                  fontSize="sm"
                  mb={2}
                >
                  {data[key]?.MESSAGE.charAt(0).toUpperCase()}
                </Circle>
              </Tooltip>
            );
          })}
        </Scrollspy>
      </VStack>
    </Box>
  );
};

export default ScrollCircle;
